import React from 'react'
import './global.css'
import Wrapper from './src/components/Wrapper'

export const wrapPageElement = ({ element, props }) => {
  const theme = props.pageContext.customTheme
  return <Wrapper customTheme={theme}>{element}</Wrapper>
}
